import institutionAPI from 'services/institutionAPI'

type Params = {
  cpf: string
}

export default async function getPersonInformationByCPF({ cpf }: Params) {
  const response = await institutionAPI({
    method: 'POST',
    url: '/external-request/search-person/mais-medicos',
    data: {
      cpf_number: cpf,
    },
  })

  return response
}
